import { Fragment, useMemo } from 'react'
import { reduce } from 'lodash'

import { Box, IconButton, TableCell, TableRow, Typography } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { map } from 'lodash'
import { format, parseISO } from 'date-fns'

import { useCanViewReadOnly } from '../../useCanConfigureApplications'
import { MODAL_NAMES } from '..'
import type { extension, deadline } from '..'

export const ROW_LABELS = {
  delete: 'Delete Extension',
  edit: 'Edit Extension',
}

type rowProps = {
  extensions: extension[]
  deadlines: deadline[]
  onOpen: ({ name, extension }: { name: string; extension?: extension }) => void
}

type extensionsById = {
  [key: string]: string
}

const ExtensionRow = ({ extensions, deadlines, onOpen }: rowProps) => {
  const readOnly = useCanViewReadOnly()
  const extensionNamesById = useMemo(() => {
    return reduce(
      deadlines,
      (acc: extensionsById, deadline: deadline) => {
        acc[deadline.Id] = deadline.Name
        return acc
      },
      {},
    )
  }, [deadlines])
  return (
    <Fragment>
      {map(extensions, (extension) => {
        const dateObj = parseISO(extension.extensionDate)
        const formattedDate = format(dateObj, 'MM/dd/yyyy')
        return (
          <TableRow key={extension.applicationExtensionId}>
            <TableCell>
              <Typography>{extension.email}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{extension.lastName}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{extensionNamesById[extension.deadlineId]}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{formattedDate}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{extension.lastUpdatedByName}</Typography>
            </TableCell>
            <TableCell>
              <Box
                mr={1}
                display="inline"
              >
                <IconButton
                  onClick={() => onOpen({ name: MODAL_NAMES.add, extension })}
                  disabled={readOnly}
                  size="small"
                  aria-label={ROW_LABELS.edit}
                >
                  <EditIcon color={readOnly ? 'disabled' : 'primary'} />
                </IconButton>
              </Box>
              <IconButton
                onClick={() => {
                  onOpen({ name: MODAL_NAMES.delete, extension })
                }}
                disabled={readOnly}
                size="small"
                aria-label={ROW_LABELS.delete}
              >
                <DeleteIcon color={readOnly ? 'disabled' : 'primary'} />
              </IconButton>
            </TableCell>
          </TableRow>
        )
      })}
    </Fragment>
  )
}

export default ExtensionRow
